// Utils
import { getUserTimezone } from './userPropertyUtils';
import { adjustLocalDateToTimezone, getUTCforAdjustedDateInTimezone } from '../../utils/timeUtil';

/**
 * This will shift a date (e.g. UTC) into the user's time, so that properties such as the
 * current day (Mon, Tues, etc) and hour will match those
 */
export const getDateAlignedToUserTimezone = (dateValue, user) => {
    const date = new Date(dateValue);
    const timezone = getUserTimezone(user);
    const timezoneAlignedTimestamp = adjustLocalDateToTimezone(date.getTime(), timezone);
    return new Date(timezoneAlignedTimestamp);
};

/**
 * Does the exact opposite to the "getDateAlignedToUserTimezone" function.
 * Instead of shifting a date so its properties look like they're in the user's timezone, we
 * start with a desired date (e.g. 4th May 7:30am) and then shift it so that the timestamp matches
 * that in UTC time.
 *
 * E.g. The date passed in is on a server in UTC time, "2022-05-04T07:30:00.000Z", but the output time
 * subtracts 10 hours to be "2022-05-03T21:30:00.000Z" which is actually 7:30am AEST.
 */
export const getLocalDateAlignedToUserUTC = (dateValue, user) => {
    const date = new Date(dateValue);
    const timezone = getUserTimezone(user) || 0;
    const timezoneAlignedTimestamp = getUTCforAdjustedDateInTimezone(date.getTime(), timezone);
    return new Date(timezoneAlignedTimestamp);
};
